define('core/helper/EventModule',[
	'jQuery',
], function($) {
	'use strict';

	var module = {
		_isEventModule_: true,
		_callbacks: {},
		on: function (eventName, callback) {
			module._callbacks[eventName] = module._callbacks[eventName] || [];
			module._callbacks[eventName].push(callback);
		},
		off: function (eventName, callback) {
			if (module._callbacks[eventName] !== undefined) {
				module._callbacks[eventName].forEach(function(_callback) {
					if (_callback === callback) {
						_callback = undefined;

						setTimeout(module._cleanup_, 2000, eventName);
					}
				});
			}
		},
		trigger: function (eventName, args) {
			if (module._callbacks[eventName] !== undefined) {

				args = $.isArray(args) ? args : [];
				args.unshift(eventName, module);

				module._callbacks[eventName].forEach(function(callback) {
					callback.apply(module, args);
				});
			}
		},
		_extend: function (newModule) {

			$.extend(true, newModule, module, newModule);

			return newModule;
		},
		_cleanup_: function (eventName) {
			module._callbacks[eventName] = module._callbacks[eventName].filter(function (value) {
				return value !== undefined;
			});
		},
	};


	return module;
});

